import axios from "axios";
import { defineStore } from "pinia";

export const useInvestmentStore = defineStore("investment", {
  state: () => ({
    loading: true,
    user_wallet: {
      data: null,
      loading: false,
      loaded: false,
    },
    wallet_profile: {
      data: null,
      loading: false,
      loaded: false,
    },
    liability: {
      data: null,
      loading: false,
      loaded: false,
    },
    user_assets: {
      data: null,
      loading: false,
      loaded: false,
    },
    broker: {
      data: null,
      loading: false,
      loaded: false,
    },
    wallet_performance: {
      data: null,
      loading: false,
      loaded: false,
    },
    asset_type: {
      data: null,
      loading: false,
      loaded: false,
    },
    meeting: {
      data: null,
      loading: false,
      loaded: false,
    },
    investmentTemplate: [
      { id: 1, class: "Renda fixa", type: "Pós fixado", classColor: "pink" },
      { id: 2, class: "Renda fixa", type: "Prefixado", classColor: "pink" },
      {
        id: 3,
        class: "Renda variável",
        type: "Renda variável Brasil",
        classColor: "green",
      },
      {
        id: 4,
        class: "Renda variável",
        type: "Renda variável global",
        classColor: "green",
      },
      {
        id: 5,
        class: "Multimercado",
        type: "Multimercados",
        classColor: "black",
      },
    ],

    liabilities: [
      {
        buy_date: "2024-11-09T17:14:25.000000Z",
        liability_type: "Financiamento",
        value: 12345,
        observation: "Passivo ou Bem",
      },
      {
        buy_date: "2024-11-09T17:14:25.000000Z",
        liability_type: "Crédito Pessoal",
        value: 12345,
        observation: "Passivo ou Bem",
      },
    ],
    wallet_planning: {
      1: {
        total_value: 2000,
      },
      2: {
        total_value: 3000,
      },
      3: {
        total_value: 4000,
      },
      4: {
        total_value: 5000,
      },
      5: {
        total_value: 6000,
      },
    },
  }),

  actions: {
    async fetchPortfolioSummary(month, year) {
      this.portfolio_summary.loading = true;

      await new Promise((resolve) => setTimeout(resolve, 1000));

      const mockData = this.getMockedPortfolioData(month, year);

      this.portfolio_summary.currentMonth = mockData.currentMonth;
      this.portfolio_summary.previousMonth = mockData.previousMonth;
      this.portfolio_summary.loaded = true;
      this.portfolio_summary.loading = false;
    },
    async getUserAssets() {
      this.user_assets.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("gestao_ativos/user_asset", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.user_assets.data = response.data.data;
        this.user_assets.loaded = true;
      } finally {
        this.user_assets.loading = false;
      }
    },

    async getWalletPerformance() {
      this.wallet_performance.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("gestao_ativos/wallet_performance", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.wallet_performance.data = response.data;
        this.wallet_performance.loaded = true;
      } finally {
        this.wallet_performance.loading = false;
      }
    },

    async getAssetTypes() {
      //axios to asset types
      this.asset_type.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("/gestao_ativos/asset_type", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.asset_type.data = response.data.data;
        this.asset_type.loaded = true;
      } finally {
        this.asset_type.loading = false;
      }
    },

    async getBroker() {
      //axios to asset types
      this.broker.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("/gestao_ativos/broker", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.broker.data = response.data.data;
        this.broker.loaded = true;
      } finally {
        this.broker.loading = false;
      }
    },

    async getInitialObjects() {
      if (this.user_assets.loaded) {
        return;
      }
      this.loading = true;
      try {
        await Promise.all([
          this.getUserAssets(),
          this.getAssetTypes(),
          this.getBroker(),
          this.getLiability(),
          this.getUserWallet(),
          this.getWalletProfile(),
          this.getWalletPerformance(),
          this.getMeeting(),
        ]);
      } finally {
        this.loading = false;
      }
    },

    async getLiability() {
      //axios to asset types
      this.liability.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("/gestao_ativos/liability", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.liability.data = response.data.data;
        this.liability.loaded = true;
      } finally {
        this.liability.loading = false;
      }
    },

    async getMeeting() {
      //axios to asset types
      this.meeting.loading = true;
      const token = this.getToken;
      const response = await axios.get("/gestao_ativos/meeting", {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.meeting.data = response.data.data;
      this.meeting.loaded = true;
      this.meeting.loading = false;
    },

    async getUserWallet() {
      //axios to asset types
      this.user_wallet.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("/gestao_ativos/user_wallet", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.user_wallet.data = response.data.data;
        this.user_wallet.loaded = true;
      } finally {
        this.user_wallet.loading = false;
      }
    },

    async getWalletProfile() {
      //axios to asset types
      this.wallet_profile.loading = true;
      const token = this.getToken;
      try {
        const response = await axios.get("/gestao_ativos/wallet_profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
        this.wallet_profile.data = response.data.data;
        this.wallet_profile.loaded = true;
      } finally {
        this.wallet_profile.loading = false;
      }
    },
  },
  getters: {
    getToken() {
      const token = localStorage.getItem("token");
      this.token = token;
      if (!token) {
        this.auth = false;
        router.push("/login");
      } else {
        this.auth = true;
      }
      return token;
    },
    assetTypeHashed() {
      if (!this.asset_type.data) {
        return {};
      }
      return this.asset_type.data.reduce((acc, type) => {
        acc[type.id] = {
          ...type,
          asset_class: type.asset_class_id_data?.name || null,
        };
        return acc;
      }, {});
    },
    userAssetClasses() {
      const typeToClassMap = this.investmentTemplate.reduce((acc, template) => {
        acc[template.id] = template.class;
        return acc;
      }, {});

      if (!this.user_assets.data) {
        return [];
      }

      return this.user_assets.data.map((asset) => {
        const resolvedClass =
          asset.asset_class_id_data?.name ||
          typeToClassMap[asset.asset_type_id] ||
          "Classe Desconhecida";

        return {
          ...asset,
          resolvedClass,
        };
      });
    },
    assetClassHashed() {
      // Criar um mapa de `id` para `class` a partir do investmentTemplate
      const typeToClassMap = this.investmentTemplate.reduce((acc, template) => {
        acc[template.id] = template.class;
        return acc;
      }, {});

      if (!this.user_assets.data) {
        return {};
      }

      // Iterar sobre os user_assets e montar o hashed
      return this.user_assets.data.reduce((acc, asset) => {
        const assetTypeId = asset.asset_type_id;

        const resolvedClass =
          typeToClassMap[assetTypeId] || "Classe Desconhecida";

        acc[assetTypeId] = {
          id: assetTypeId,
          class: resolvedClass,
          asset: asset.asset_type_id_data?.name || "Tipo Desconhecido",
          color: asset.asset_type_id_data?.color || "#CCCCCC", // Default color se não existir
        };

        return acc;
      }, {});
    },
    brokerHashed() {
      if (!this.broker.data) {
        return {};
      }
      return this.broker.data.reduce((acc, broker) => {
        acc[broker.id] = broker;
        return acc;
      }, {});
    },
    walletProfileHashed() {
      if (!this.wallet_profile.data) {
        return {};
      }
      return this.wallet_profile.data.reduce((acc, walletProfile) => {
        acc[walletProfile.id] = walletProfile;
        return acc;
      }, {});
    },
    liabilityBalance() {
      if (!this.liability.data || !Array.isArray(this.liability.data)) {
        return { property: 0, debt: 0 };
      }
      return this.liability.data.reduce(
        (acc, liabilityItem) => {
          const type = liabilityItem.liability_type?.toLowerCase();
          if (type === "property" || type === "debt") {
            acc[type] = (acc[type] || 0) + Number(liabilityItem.amount);
          }
          return acc;
        },
        { property: 0, debt: 0 }
      );
    },
    totalBalanceByType() {
      if (!this.wallet_performance.data) {
        return {};
      }
      const balanceByType = Object.values(
        this.wallet_performance.data.balance_by_type
      );
      return balanceByType.reduce((acc, type) => {
        acc += type;
        return acc;
      }, 0);
    },
    targetDistributionByType() {
      if (!this.user_wallet.data || !this.user_wallet.data[0]) {
        return {};
      }
      const typeDistribution = JSON.parse(
        this.user_wallet.data[0].wallet_profile_id_data.type_distribution
      );
      return typeDistribution;
    },
    targetDistributionByClass() {
      const typeToClassMap = this.investmentTemplate.reduce((acc, template) => {
        acc[template.id] = template.class;
        return acc;
      }, {});

      const typeDistribution = this.targetDistributionByType;

      return Object.entries(typeDistribution).reduce(
        (acc, [typeId, percentage]) => {
          const className = typeToClassMap[typeId] || "Classe Desconhecida";
          if (!acc[className]) {
            acc[className] = 0;
          }
          acc[className] += parseFloat(percentage);
          return acc;
        },
        {}
      );
    },
  },
});
